import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Modal from 'react-modal';
import Cookies from 'js-cookie';
import { styled } from "@mui/material/styles";
// import { history } from './../routers/Router';
// import createHistory from 'history/createBrowserHistory';
import utf8 from 'utf8';
import uniqid from 'uniqid';
import ErrorText from '../ErrorText';
import '../css/AddNewChannel.css';


// add new channel for the ai part old implementation component
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    minHeight: '40%',
    overflow: 'auto',
    padding: '2%',
  }
};

const styles = theme => ({
  root: {
    display: 'flex',
  },
  formControl: {
    minWidth: 120,
    width: '100%',
    border: 'none'
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 4,
    width: '60vw',
  },
});


class AddNewChannel extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: false,
      modalIsOpenEdit: false,
      channelName: '',
      channelNumber: '',
      ChannelArray: '',
      ChannelGenre: '',
      ChannelLogoUrl: '',
      showErrorMessage: false,
    };
    this.closeModal = this.closeModal.bind(this);
  }
  closeModal() {
    this.setState({
      modalIsOpen: false
    });
    window.location.href ='/ai/addnewchannel';
  }


  AddChannelhandler = (e) => {
    let channel_name = this.state.channelName;
    let genre = this.state.ChannelGenre;
    let channel_Array = this.state.ChannelArray;
    let channel_Number = this.state.channelNumber;
    // let new_channel_logo = this.state.ChannelLogoUrl;
    let logo = utf8.encode(this.state.ChannelLogoUrl.toString());
    var tokenStored = localStorage.getItem('token');
    tokenStored = `Token ${tokenStored}`
    var headers = {
      'Content-Type': 'application/json',
      "Access-Control-Allow-Origin": "*",
      'X-CSRFToken': localStorage.getItem('csrftoken'),
      'Authorization': tokenStored
    }

    let xx = JSON.stringify({
      channel_name,
      genre,
      channel_Array,
      channel_Number,
      logo
    })

    fetch('/cloud/new_channel_data/', {
      method: "post",
      headers: headers,
      body: xx
    })
      .then(response => {
        if (response.status == 200) {
          this.setState({
            modalIsOpen: true
          })
        }
        else {
          alert('Something went wrong.Action not completed.');
          // const history = createHistory({ forceRefresh: true })
          window.location.href ='/ai/addnewchannel';
        }
      })
               .then(response => {
              if(response.status===403){
                localStorage.removeItem('token');
                localStorage.removeItem('csrftoken');
                localStorage.removeItem('auth');
                // const history = createHistory({forceRefresh: true})
                window.location.href ='/session-timeout'
              }else{
                  return response.json()}
              })
      .then(data => console.log(data))
      .catch(error => console.error(error))
  }

  onAddClick = () => {
    this.setState({
      showErrorMessage: true
    }, () => {
      this.fetchError((e) => {
        if (e === 'NoError') {
          this.AddChannelhandler();
        }
      })
    })
  }


  onReset = () => {
    // const history = createHistory({ forceRefresh: true })
    window.location.href ='/ai/addnewchannel';

  }
  getBase64 = (event) => {
    var input = event.target;
    console.log(event.target)
    var reader = new FileReader();
    reader.onload = () => {
      this.setState({
        ChannelLogoUrl: reader.result,
      }, () => {
        console.log(this.state.ChannelLogoUrl)
      })
    }
    reader.readAsDataURL(input.files[0]);
  };


  fetchError = (noError) => {
    var totalError = 4;
    if (ErrorText('isChannelName', this.state.channelName.trim()) === 'No Error') {
      totalError = totalError - 1;
    }
    if (ErrorText('isChannel', this.state.channelNumber) === 'No Error') {
      totalError = totalError - 1;
    }
    if (ErrorText('notEmpty', this.state.ChannelGenre.trim()) === 'No Error') {
      totalError = totalError - 1;
      console.log('called hrer')
    }
    if (ErrorText('notEmpty', this.state.ChannelLogoUrl.trim()) === 'No Error') {
      totalError = totalError - 1;
    }
    if (totalError === 0) {
      noError('NoError');
    }
  }


  render() {
    const { classes } = this.props;
    return (
      <div className="AddNewChannel">
        <div className="row editchannel-heading leading ">
          New channel details
              </div>
        <div className="row">
          <div className="col-6">
            <div className="row row-edit">
              <div className="group">
                <input type="text" name="channelName" ref="channelName" className="row-edit" style={{ backgroundColor: 'transparent' }}
                  value={this.state.channelName}
                  onChange={(e) => {
                    if(e.target.value.length<=40){
                      this.setState({
                        channelName: e.target.value
                      })
                    }
                  }
                  }
                  required />
                <span className="highlight"></span>
                <span className="bar"></span>
                <label>Channel Name</label>
                <span className="error text-danger" style={{ fontSize: '.75rem' }}>{ErrorText('isChannelName', this.state.channelName.trim()) !== 'No Error' && this.state.showErrorMessage ? 'Invalid channel name' : ''}</span>
              </div>
            </div>
            <div className="row row-edit">
              <div className="group">
                <input type="text" name="channelNumber" ref="channelNumber" className="row-edit" style={{ backgroundColor: 'transparent' }}
                  value={this.state.channelNumber}
                  onChange={(e) => {
                    var str = e.target.value.toString().trim();
                    if (str.length <= 4 && !isNaN(str)) {
                      if (str.length == 3) {
                        str = `0${str}`
                      } else if (str.length == 2) {
                        str = `00${str}`
                      } else if (str.length == 1) {
                        str = `000${str}`
                      }
                      
                      this.setState({
                        channelNumber: e.target.value,
                        ChannelArray: str
                      })
                    }
                  }
                  }
                  required />
                <span className="highlight"></span>
                <span className="bar"></span>
                <label>Channel Number</label>
                <span className="error text-danger" style={{ fontSize: '.75rem' }}>{ErrorText('isChannel', this.state.channelNumber) !== 'No Error' && this.state.showErrorMessage ? 'Invalid channel number' : ''}</span>
              </div>
            </div>
            <div className="row row-edit disableEvent">
              <div className="group">
                <input type="text" name="ChannelArray" ref="ChannelArray" className="row-edit" style={{ backgroundColor: 'transparent' }}
                  value={this.state.ChannelArray}
                  onChange={(e) => {
                    this.setState({
                      ChannelArray: e.target.value
                    })
                  }
                  }
                  required />
                <span className="highlight"></span>
                <span className="bar"></span>
                <label>Channel Array</label>
              </div>
            </div>
            <div className="row row-edit">
              <div className="group">
                <input type="text" name="ChannelGenre" ref="ChannelGenre" className="row-edit" style={{ backgroundColor: 'transparent' }}
                  value={this.state.ChannelGenre}
                  onChange={(e) => {
                    if(e.target.value.length<=40){
                      this.setState({
                        ChannelGenre: e.target.value
                      })
                    }
                  }
                  }
                  required />
                <span className="highlight"></span>
                <span className="bar"></span>
                <label>Channel Genre</label>
                <span className="error text-danger" style={{ fontSize: '.75rem' }}>{ErrorText('notEmpty', this.state.ChannelGenre.trim()) !== 'No Error' && this.state.showErrorMessage ? 'Genre must not be empty' : ''}</span>
              </div>
            </div>            
            <div className="row">
            <div className="group pointer" >            
            <label htmlFor="dd" style={{pointerEvents: "all", width: '100px'}}>Browse Image</label>
            <input id="dd" type='file' accept=".jpg,.png" onChange={this.getBase64.bind(this)} style={{display: 'none'}} />
              <div className="group">
                <span className="error text-danger" style={{ fontSize: '.75rem' }}>{ErrorText('notEmpty', this.state.ChannelLogoUrl.trim()) !== 'No Error' && this.state.showErrorMessage ? 'Select image in png or jpg format only' : ''}</span>
              </div>
            </div>
            </div>
          </div>
          <div className="col-4 image-position m-3" key="asdbhj">
            <img src={this.state.ChannelLogoUrl} key={uniqid()} />
          </div>
        </div>

        <div className="swubmitbutton">
          <Link to='/ai/addchannel'>
            <div className="btn reset-btn mx-2 px-5">Cancel </div>
          </Link>
          <div className="btn reset-btn mx-2 px-5" onClick={this.onReset.bind(this)}>Reset </div>
          <button className="btn edit-btn px-5" onClick={this.onAddClick.bind(this)}>Add</button>
        </div>
        <Modal
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          style={customStyles}
          contentLabel="Example Modal">
          <div className="modal-add-device">
            <div className="float-right cross-times" onClick={this.closeModal}>
              <i className="fas   fa-2x mr-2"></i>
            </div>
          </div>
          <div className="display-4 text-center">
            <h3 className="modal-heading thanks-message">Thanks for Updation</h3>
            <i class="fas fa-check-circle update"></i>
            <br />
            <Link to='/ai/dashboard'>
              <div className="btn reset-btn mx-2 px-5" >Home </div>
            </Link>
            <Link to='/ai/addnewchannel' forceRefresh={true}>
              <div className="btn add-new-btn mx-2 px-5" onClick={this.onReset.bind(this)} >Add Another One</div>
            </Link>
          </div>
        </Modal>
      </div>
    );
  }
}


AddNewChannel.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default styled(styles)(AddNewChannel);
